import React, { Component } from "react";
import { View, StyleSheet, TouchableHighlight, ViewStyle } from "react-native";
import Text from "../components_v2/TextFont";
import { SimpleIcon } from "../components_v2/Buttons";
import Theme from "../argon-ui/Theme";
import {
  faCheckCircle,
  faHome,
  faQrcode,
} from "../../assets/consts/faCharCodes";
export type propTypes = {
  homeUserProfile?: boolean;
  serverId: string;
  buildingCode?: string;
  buildingId: string;
  buildingName: string;
  userId?: string;
  userFullName?: string;
  selected: boolean;
  style?: ViewStyle;
  onSelect: () => void;
  onShowQRCodeModal?: () => void;
};

import { IconButton } from "native-base";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { getIsRTL } from "../util";

export default class UserProfile extends Component<propTypes> {
  handleOnPress = () => {
    typeof this.props.onSelect === "function" && this.props.onSelect();
  };
  handleOnQRCodePress = () => {
    typeof this.props.onShowQRCodeModal === "function" &&
      this.props.onShowQRCodeModal();
  };
  render() {
    let { selected } = this.props;
    let theme = selected ? SelectedStyle : normalStyle;
    return (
      <TouchableHighlight
        style={[styles.wrapper, theme.wrapper, { ...this.props.style }]}
        onPress={this.handleOnPress}
        underlayColor={
          this.props.homeUserProfile
            ? Theme.COLORS.LIGHT_MAIN
            : Theme.COLORS.PRIMARY
        }
      >
        <View
          style={[
            {
              flexDirection: getIsRTL() ? "row" : "row-reverse",
              alignItems: "center",
              // direction: getDir(),
            },
          ]}
        >
          <SimpleIcon
            icon={selected ? faCheckCircle : faHome}
            style={{ width: 45, paddingHorizontal: 10 }}
            color={selected ? Theme.COLORS.WHITE : Theme.COLORS.MUTED}
            size={20}
          />
          <View style={{ flex: 1, paddingHorizontal: 5 }}>
            <Text style={[styles.buildingName, theme.buildingName]}>
              {this.props.buildingName}
            </Text>
            {/* <Text style={[styles.userFullName, theme.userFullName]}>
              {this.props.userFullName}
            </Text> */}
          </View>
          {/* === QR code === */}
          {this.props.buildingCode && (
            <IconButton
              alignSelf="center"
              colorScheme="error"
              variant="solid"
              style={[
                styles.btnRemove,
                selected
                  ? { shadowColor: Theme.COLORS.WHITE }
                  : { borderColor: Theme.COLORS.PRIMARY, borderWidth: 1 },
              ]}
              onPress={this.handleOnQRCodePress}
              icon={
                <FontAwesomeIcon
                  icon={faQrcode}
                  size={14}
                  color={Theme.COLORS.PRIMARY}
                />
              }
            />
          )}
          {/* <SimpleIcon
            icon={faArrowLeft}
            style={{ width: 45, paddingHorizontal: 5, textAlign: "center" }}
            color={selected ? Theme.COLORS.WHITE : Theme.COLORS.MUTED}
            size={12}
          /> */}
        </View>
      </TouchableHighlight>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    borderColor: Theme.COLORS.STATUS_BAR,
    borderWidth: 1,
    borderRadius: 8,
    height: 55,
    padding: 10,
    marginHorizontal: 5,
    justifyContent: "center",
  },
  userFullName: {
    fontSize: 11,
  },
  buildingName: {
    fontWeight: "bold",
    fontSize: 14,
  },
  btnRemove: {
    backgroundColor: Theme.COLORS.WHITE,
    borderRadius: 10,
    padding: 3,
    width: 35,
    height: 35,
    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
});

const normalStyle = StyleSheet.create({
  wrapper: {
    // width: "100%",
    // backgroundColor: ArTheme.COLORS.WHITE,
    backgroundColor: Theme.COLORS.GRAY_LIGHT,
    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },

  userFullName: {
    color: Theme.COLORS.MUTED,
  },
  buildingName: {
    color: Theme.COLORS.MUTED,
  },
});

const SelectedStyle = StyleSheet.create({
  wrapper: {
    backgroundColor: Theme.COLORS.PRIMARY,
    borderColor: Theme.COLORS.WHITE,
    borderWidth: 1,
    shadowColor: Theme.COLORS.PRIMARY,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  userFullName: {
    color: Theme.COLORS.WHITE,
  },
  buildingName: {
    color: Theme.COLORS.WHITE,
  },
});
